import { Component, Input, Output } from '@angular/core';
import { AppState } from '../../../../app.service';
import { ReplicatedService } from './replicated.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { constructInnerTableRestorePoints } from '../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { Modal, State } from '@clr/angular';
import { StorageComparator } from '../../dataprotection-common/comparator';
import { formatDateTimeCustom } from '../../../../../common/utils/utils';
var $ = require('jquery');

@Component({
  selector: 'replicated-restore-points-vm',
  providers: [
    ReplicatedService, TranslateService
  ],
  styles: [require('./replicated-vdc.scss')],
  template: require('./restore-points-vm.html')
})

export class ReplicatedRestorePointsVm {
  @Input() isVisible: boolean;
  @Input() mode: string;
  @Input() selectedEntity: any = null;
  private loading: boolean = false;
  private replicatedRestorePointsVms: any;
  private pageSize: number = 5;
  private subscribeHandler;

  constructor(public appState: AppState, public service: ReplicatedService, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    this.getReplicatedRestorePointsVms();
  }

  ngOnChanges(changes) {
    if (changes && changes.hasOwnProperty('isVisible') && changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue) {
      this.getReplicatedRestorePointsVms();
    }
  }

  refresh(state: State) {
    this.loading = true;
    this.getReplicatedRestorePointsVms();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  getReplicatedRestorePointsVms() {
      this.replicatedRestorePointsVms = this.selectedEntity && this.selectedEntity.children ? this.selectedEntity.children : [];
      this.loading = false;
  }

  formatDateTime(timeStamp) {
    return formatDateTimeCustom(timeStamp);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/restore-points-vm.component.ts